import { Navigate, useParams } from 'react-router-dom'
import useFeature, { features } from '@/hooks/useFeature'
import { LISTING_PATH } from './listing-config'
import SubmittalsListingPage from './SubmittalsListingPage'
import SubmittalsTabbedListingPage from './SubmittalsTabbedListingPage'

/**
 * Which Submittals listing renders, decided by SUBMITTALS_PHASE_2.
 *
 * With the flag off this is the single hardcoded Environmental Monthly
 * Submissions table, unchanged and unscoped. With it on, one listing per data
 * element, each drawn from its own `listingConfig` and addressed by its own URL.
 */
const SubmittalsPage = () => {
  const isPhase2 = useFeature(features.SUBMITTALS_PHASE_2)
  const { dataElementId } = useParams()

  // `/submittals/de/:dataElementId` only means something to the tabbed listing —
  // the legacy one has no concept of a selected data element and would render the
  // unscoped table under a URL claiming otherwise. With the flag off the route
  // collapses back to the bare listing.
  if (!isPhase2) {
    return dataElementId ? <Navigate to={LISTING_PATH} replace /> : <SubmittalsListingPage />
  }

  return <SubmittalsTabbedListingPage />
}

export default SubmittalsPage
